// extracted by mini-css-extract-plugin
export default {"root":"BlockFooter_root__Gm+wm","media":"BlockFooter_media__62k2S","text":"BlockFooter_text__uhl6v"};